import React from 'react';
import { createComponent } from '@lit/react';
import { IxList as LitComp } from '../IxList.js';

customElements.define('ix-list', LitComp);

export const IxList = createComponent({
  tagName: 'ix-list-react',
  elementClass: LitComp,
  react: React,
});
